import {Injectable} from '@angular/core';

export interface TranslationResult {
    language: string;
    newTranslations: object;
    fullMergedJson: object;
    isNew?: boolean;
}

export type InputFormat = 'separate' | 'combined';

@Injectable({
    providedIn: 'root',
})
export class WizardDataService {
    inputFormat: InputFormat = 'separate';

    // Screen 1 Data
    apiKey: string = '';
    selectedModel: string = 'google/gemini-3.1-flash-lite-preview';
    baseLanguage: string = 'en';
    targetLanguages: string[] = [];

    // Screen 2 Data
    baseJson: object | null = null;
    baseJsonString: string = '';
    targetJsonMap: Map<string, object> = new Map();

    // Screen 3 & 4 Data
    translationResults: Map<string, TranslationResult> = new Map();

    constructor() {}

    reset(): void {
        this.inputFormat = 'separate';
        this.apiKey = '';
        this.selectedModel = 'google/gemini-3.1-flash-lite-preview';
        this.baseLanguage = 'en';
        this.targetLanguages = [];
        this.baseJson = null;
        this.baseJsonString = '';
        this.targetJsonMap.clear();
        this.translationResults.clear();
    }
}
